export const shortDateFormatHelper = (
  date: string,
  locale?: string
): string => {
  const d = new Date(date);

  if (Number.isNaN(d.getTime())) {
    return "";
  }

  const formatter = new Intl.DateTimeFormat(locale?.replace("_", "-"), {
    day: "2-digit",
    month: "short",
  });

  const parts = formatter.formatToParts(d);

  const day = parts.find((p) => p.type === "day")?.value || "";
  let month = parts.find((p) => p.type === "month")?.value || "";

  month = month
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());

  return `${month} ${day}`;
};

export const formattedDate = (
  date: Date,
  locale: string | undefined
): string => {
  return date.toLocaleDateString(locale?.replace("_", "-"), {
    day: "numeric",
    month: "short",
    year: "numeric",
    weekday: undefined,
  });
};

export function formatDateWithTime(
  date: Date,
  locale = "en-US",
  time24 = false
): string {
  const formattedDate = date.toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

  const formattedTime = date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: time24 ? false : undefined,
  });

  return `${formattedDate}, ${formattedTime}`;
}
